import { unitSelectors as selector } from "../Selectors/index";

const initValue = {
  loading: false,
  rows: [],
};

export const unitReducer = (state = initValue, { type, payload }) => {
  switch (type) {
    case selector.GET:
      return {
        ...state,
        loading: true,
      };
    case selector.GET_SUCCESS:
      return {
        loading: false,
        rows: payload,
      };

    default:
      return state;
  }
};
